import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGS, T } from "./translations";

export { LANGS, T };

const STORAGE_KEY = "deseos-lang";
const DEFAULT = "es";

// Le site s'ouvre TOUJOURS en espagnol.
// Seul un visiteur qui a déjà choisi une autre langue la retrouve ensuite :
// aucune détection automatique depuis la langue du navigateur.
const detect = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && T[saved]) return saved;
  } catch (e) {
    /* localStorage indisponible : on ignore */
  }
  return DEFAULT;
};

const LangContext = createContext({ lang: DEFAULT, setLang: () => {}, t: T[DEFAULT] });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);

  useEffect(() => {
    const meta = LANGS.find((l) => l.code === lang) || LANGS[0];
    document.documentElement.lang = meta.code;
    document.documentElement.dir = meta.dir;
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      /* localStorage indisponible : on ignore */
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang: setLangState,
      t: T[lang] || T[DEFAULT],
      dir: (LANGS.find((l) => l.code === lang) || LANGS[0]).dir,
      locale: (LANGS.find((l) => l.code === lang) || LANGS[0]).locale,
    }),
    [lang]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
